import React from 'react';
import { useAppSelector } from '@shared/hooks/use-app-selector';
import {
  HUBSPOT_ID,
  BEAMER_ID,
  NOTIFICATION_ELEMENT_ID,
  INTERCOM_APP_ID,
} from '../../constants';
import { HubSpotWidget as HubSpot } from './HubSpot';
import { DelightedWidget as Delighted } from './Delighted';
import { BeamerWidget as Beamer } from './Beamer';
import { IntercomChatbot } from './Intercom';

const isAccountFullyLoaded = (account) =>
  account.id !== null &&
  account.contractDetails.defaultPaymentSourceType !== undefined;

function Widgets({
  account,
  activateHubSpot,
  locale,
  merchant,
  segments,
  showDelighted,
  showHubspot,
  showIntercomChatbot,
  isUserAdmin,
  isContractApp,
  isPaidUser,
  isKeyAccount,
  hubspotChatflow,
  beamerCustomAttributes,
  delightedCustomAttributes,
  onHubspotReady,
  onIntercomReady,
}) {
  const currentMerchant = useAppSelector((state) => state.currentMerchant);

  const merchantId = currentMerchant?.id || '';
  const merchantSource = currentMerchant?.source || '';

  const shouldDisplayHubspot = HUBSPOT_ID && activateHubSpot;

  if (merchantId && merchantSource === 'onecom_wsb') return null;

  return (
    <div>
      {BEAMER_ID && isAccountFullyLoaded(account) && !isContractApp && (
        <Beamer
          email={account.email}
          firstName={account.firstName}
          lastName={account.lastName}
          locale={locale}
          productId={BEAMER_ID}
          segments={segments}
          targetElementId={NOTIFICATION_ELEMENT_ID}
          userId={account.id}
          customAttributes={beamerCustomAttributes}
        />
      )}
      {shouldDisplayHubspot && !showIntercomChatbot && (
        <HubSpot
          hubId={HUBSPOT_ID}
          show={showHubspot}
          chatflow={hubspotChatflow}
          email={account.email}
          organizationId={account.organizationId}
          onHubspotReady={onHubspotReady}
        />
      )}
      {showDelighted && account.email !== '' && (
        <Delighted
          email={account.email}
          locale={account.locale}
          delightedCustomAttributes={delightedCustomAttributes}
        />
      )}
      {showIntercomChatbot && (
        <IntercomChatbot
          appId={INTERCOM_APP_ID}
          userId={account.id}
          email={account.email}
          name={[account.firstName, account.lastName].filter(Boolean).join(' ')}
          isUserAdmin={isUserAdmin}
          isPaidUser={isPaidUser}
          isKeyAccount={isKeyAccount}
          merchantId={merchant.id}
          merchantLocale={account.locale}
          merchantPhoneNumber={merchant.phoneNumber}
          merchantIndustry={merchant.category}
          organizationId={account.organizationId}
          organisationName={account.organisationName}
          onIntercomReady={onIntercomReady}
          merchantCreatedAt={merchant.createdAt}
        />
      )}
    </div>
  );
}

export default Widgets;
